import {
  CREATE_PHONE_CODE_SIGNUP_SUCCESS,
  CREATE_PHONE_CODE_SIGNUP,
  CREATE_PHONE_CODE_SIGNUP_FAILURE,
  RESET_STORE
} from './signupActions';

const initialState = {
  loading: false,
  createPhoneCodeSuccess: false
};

const signupReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_STORE:
      return initialState;
    case CREATE_PHONE_CODE_SIGNUP:
      return {
        ...state,
        loading: true
      };
    case CREATE_PHONE_CODE_SIGNUP_SUCCESS:
      return {
        ...state,
        createPhoneCodeSuccess: true,
        loading: false
      };
    case CREATE_PHONE_CODE_SIGNUP_FAILURE:
      return {
        ...state,
        createPhoneCodeSuccess: false,
        loading: false
      };
    default:
      return state;
  }
};

export default signupReducer;
